export default "__VITE_ASSET__BvWoAmh4__"